import React from 'react';
import { decimalTo } from '../../utils/utils';

function convertExponentialToDecimal(exponentialNumber) {
  const str = exponentialNumber.toString();
  const strVal = str.split(/[eE]/);
  if (strVal.length > 0) {
    return parseFloat(strVal[0]).toFixed(2);
  }
}

export const ProductDataColumns = (region) => [
  {
    name: 'S.No',
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.productId} />
        <span>{index + 1}</span>
      </>
    ),
    ignoreRowClick: true,
  },
  {
    name: 'Product',
    selector: (row) => row.productName, 
    cell: (row) =>
      row.productName ? (
        <span className="add-ellip">{row.productName}</span>
      ) : (
        ''
      ),
  },
  {
    name: 'Total Sold Quantity',
    selector: (row) => row.totalSaleQuantity, 
  },
  {
    name: 'Total Order Amount',
    selector: (row) => row.totalSaleAmount,
    cell: (row) => (
      <>
        <input type="hidden" value={row.dateVelue} />
        <span>{decimalTo(row.totalSaleAmount).toFixed(2)}</span>
      </>
    ),
  },
  {
    name: 'Total Margin Amount',
    selector: (row) => row.totalSaleProfit,
    cell: (row) => (
      <>
        <input type="hidden" value={row.dateVelue} />
        <span>{decimalTo(row.totalSaleProfit).toFixed(2)}</span>
      </>
    ),
  },
  {
    name: `Net Amount${region?.currency ? ` (${region.currency})` : ''}`,
    selector: (row) => row.totalnetamount,width: "200px",
    cell: (row) => (
      <>
        <input type="hidden" value={row.dateVelue} />
        <span>{decimalTo(row.totalnetamount).toFixed(2)}</span>
      </>
    ),
    sortable: false,
  },
 
];

export const ProductDataColumnsMerchant = (region) => [
  {
    name: 'S.No',
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.productId} />
        <span>{index + 1}</span>
      </>
    ),
    ignoreRowClick: true,
    button: true,
  },
  {
    name: 'Product',
    selector: (row) => row.productName,
    cell: (row) =>
      row.productName ? (
        <span className="add-ellip">{row.productName}</span>
      ) : (
        ''
      ),
  },
  {
    name: 'Total Purchase Qty',
    selector: (row) => row.totalSaleQuantity,
  },
  {
    name: 'Total Order Amount',
    selector: (row) => row.totalSaleAmount,
  },
  {
    name: 'Total Margin Amount',
    selector: (row) => row.totalSaleProfit,
    cell: (row) => {
      const data = row.totalSaleProfit;
      const isInteger = Number.isInteger(data);
      return <span>{isInteger ? data : convertExponentialToDecimal(data)}</span>;
    },
  }
 
];
